import { useMutation } from "@tanstack/react-query";
import classNames from "classnames";
import { putRequestByAuth } from "../../../../../../function/helper";
import useMessageTicket from "../../../../../../hooks/useMessageTicket";

function ReadTicketButton({ isReadAnswer, ticketId, onClick, onRead }) {
  const { reduceUnreadTickets } = useMessageTicket();

  const { mutate } = useMutation({
    mutationKey: ["read-ticket"],
    mutationFn: () =>
      putRequestByAuth("/setting/v1/ticket/read", { ticketId }).then(res => {
        if (res && res.status === 200) {
          reduceUnreadTickets(ticketId);
          onRead(ticketId);
        }

        return null;
      }),
  });

  return (
    <button
      className={classNames("btn", {
        "button-outline-secondary": isReadAnswer,
        "btn-outline-success": !isReadAnswer,
      })}
      type="button"
      onClick={() => {
        if (!isReadAnswer) {
          mutate();
        }
        onClick();
      }}
    >
      مشاهده
    </button>
  );
}
export default ReadTicketButton;
